
import axios from "./axios";
import { URLs } from "../Utility/Constants";
import { apiRequest } from "./ApiUtility";

// Removed duplicate and incomplete function definitions for addNewBill and updateVisit




export async function addNewBill(authContext, visitId) {
  const url = URLs.BillingAPI;
  const data = { visitId };
  return await apiRequest("post", url, authContext, data);
}

export async function updateVisit(authContext, facilityId, statusList = []) {
  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  if (!facilityId) {
    console.error("Missing facilityId");
    return { isSuccess: false, data: "Invalid facility ID" };
  }

  // Calculate 'from' (30 days ago) and 'to' (current date)
  const currentDate = new Date();
  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(currentDate.getDate() - 30);

  // Format dates as YYYY-MM-DD
  const from = thirtyDaysAgo.toISOString().split("T")[0];
  const to = currentDate.toISOString().split("T")[0];

  const url = `/api/visit/facility/${facilityId}`;
  const data = { from, to, statusList };
  return await apiRequest("post", url, authContext, data);
}

export async function fetchBillingDetails(authContext, facilityId, from, to) {
  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  if (!facilityId || !from || !to) {
    console.error("Missing required parameters: facilityId, from, to");
    return { isSuccess: false, data: "Invalid request parameters" };
  }

  // For cache-control header, we need to handle this specially
  const BILLING_GETALL_API_URL = `${URLs.BillingAPI}/getall`;
  let result = {};

  try {
    const response = await axios.post(
      BILLING_GETALL_API_URL,
      { facilityId, from, to },
      {
        headers: {
          Authorization: "Bearer " + authContext?.authToken,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
      }
    );

    result.isSuccess = true;
    result.data = response?.data;
  } catch (error) {
    result.isSuccess = false;
    result.data = error?.response?.data || "Unknown error";
    console.error("API Error: ", error);
  }

  return result;
}

export async function viewBillById(authContext, billId) {
  // Special handling for blob response - keeping original implementation
  if (authContext && billId) {
    const VIEW_BILL_URL = "/api/billing/download";
    var result = {};
    await axios
      .get(VIEW_BILL_URL + "/" + billId, 
      {
        headers: {
          Authorization: "Bearer " + authContext.authToken,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        responseType: "blob",
      })
      .then(function (response) {
        result.isSuccess = true;
        const pdfBlob = new Blob([response?.data], {type: "application/pdf"});
        const url = window.URL.createObjectURL(pdfBlob);
        window.open(url);
      })
      .catch(function (error) {
        result.isSuccess = false;
        result.data = error?.response?.data;
      });
    return result;
  }
}

export async function fetchServicesByVisitApi(authContext, visitId) {
  const url = `/api/providedservices/visit/${visitId}`;
  return await apiRequest("get", url, authContext);
}

export async function addServiceToBillApi(authContext, billId, serviceId, discountPercentage) {
  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  if (!billId || !serviceId) {
    console.error("Missing required parameters: billId or serviceId");
    return { isSuccess: false, data: "Invalid request parameters" };
  }

  const url = `/api/providedservices/addtoBill`;
  const data = { billId, serviceId, discountPercentage };
  return await apiRequest("post", url, authContext, data);
}

export async function addPayment(authContext, patientId, facilityId, amount, paymentMode, notes, attachToBill, billId, isAdvancePayment, receivedFrom) {
  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  const url = `/api/payment/addpayment`;
  const data = { 
    patientId, 
    facilityId, 
    amount, 
    paymentMode, 
    notes, 
    attachToBill, 
    billId, 
    isAdvancePayment, 
    receivedFrom 
  };
  return await apiRequest("post", url, authContext, data);
}

export async function addRefund(authContext, billId, amount, mode, notes, refundedTo) {
  const url = `/api/payment/addrefund`;
  const data = { billId, amount, mode, notes, refundedTo };
  return await apiRequest("post", url, authContext, data);
}

export async function removePayment(authContext, id) {
  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  if (!id) {
    console.error("Missing required parameter: id");
    return { isSuccess: false, data: "Invalid request parameters" };
  }

  const url = `/api/payment/removepayment/${id}`;
  return await apiRequest("delete", url, authContext);
}

export async function removeRefund(authContext, id) {
  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  if (!id) {
    console.error("Missing required parameter: id");
    return { isSuccess: false, data: "Invalid request parameters" };
  }

  const url = `/api/payment/removerefund/${id}`;
  return await apiRequest("delete", url, authContext);
}

export async function removeService(authContext, id) {
  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  if (!id) {
    console.error("Missing required parameter: serviceId");
    return { isSuccess: false, data: "Invalid request parameters" };
  }

  const url = `/api/providedservices/removefrombill/${id}`;
  return await apiRequest("post", url, authContext, {});
}




  export async function getBillById(authContext, billId) {
    const  GET_BILL_DETAILS_API_URL =`/api/billing/${billId}`;
    let result = {};
  
    if (!authContext?.authToken) {
      console.error("Missing authentication context");
      return { isSuccess: false, data: "Unauthorized" };
    }
  
    try {
      const response = await axios.get(GET_BILL_DETAILS_API_URL, {
        headers: {
          Authorization: `Bearer ${authContext.authToken}`,
          Accept: "application/json",
        },
      });
  
      result.isSuccess = true;
      result.data = response?.data;
    } catch (error) {
      result.isSuccess = false;
      result.data = error?.response?.data || "Unknown error";
      console.error("API Error: ", error);
    }
  
    return result;
  }
export async function removeBill(authContext, billId) {
  const REMOVE_BILL_API_URL = `/api/billing/${billId}`;
  let result = {};

  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  if (!billId) {
    console.error("Missing required parameter: billId");
    return { isSuccess: false, data: "Invalid request parameters" };
  }

  try {
    await axios.delete(REMOVE_BILL_API_URL, {
      headers: {
        Authorization: `Bearer ${authContext.authToken}`,
        Accept: "application/json",
      },
    });

    result.isSuccess = true;
  } catch (error) {
    result.isSuccess = false;
    result.data = error?.response?.data || "Unknown error";
    console.error("API Error (Remove Bill): ", error);
  }

  return result;
}
export async function settleBill(authContext, billId) {
  const SETTLE_BILL_API_URL = `/api/billing/bill/settle`;
  let result = {};

  if (!authContext?.authToken) {
    console.error("Missing authentication context");
    return { isSuccess: false, data: "Unauthorized" };
  }

  if (!billId) {
    console.error("Missing required parameter: billId");
    return { isSuccess: false, data: "Invalid request parameters" };
  }

  try {
    const response = await axios.post(
      SETTLE_BILL_API_URL,
      { billId }, // Pass billId in the request body
      {
        headers: {
          Authorization: `Bearer ${authContext.authToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    result.isSuccess = true;
    result.data = response?.data;
  } catch (error) {
    result.isSuccess = false;
    result.data = error?.response?.data || "Unknown error";
    console.error("API Error (Settle Bill): ", error);
  }

  return result;


}
  